const MEETS = [
  {
    title: 'NERG 2018',
    dates: 'July 14th & 15th 2018',
    url: 'http://www.ukvac.com/forum/nerg-2018-14th-15th-july_topic360402.html',
    objectID: 0
  },
   
   {
    title: 'Smartmeet 7',
    dates: 'August 12th 2018',
    url: 'http://www.ukvac.com/forum/smartmeet-7_topic364358.html',
    objectID: 3
  },
  {
    title: 'UKVAC meet @ Arcade Club',
    dates: 'September 15th & Sun 16th 2018',
    url: 'http://www.ukvac.com/forum/ukvac-meet-2018-arcade-club_topic363191.html',
    objectID: 2
  },
  {
    title: 'Forum Migration to new platform',
    dates: 'TBC 2018',
    url: 'http://www.ukvac.com/forum/announcement-forum-migration_topic363634.html',
    objectID: 4
  }

];

export default MEETS;


// WEBPACK FOOTER //
// ./src/data-meets.js